import * as React from 'react';
import { useState } from 'react';

import { Color, IconName } from '../../enums';
import { UseState } from '../../types';
import { Icon } from '../icon/icon.component';

import { BrokenImageBox, Img } from './image.styled';
import { ImageProps } from './image.types';

export const Image: React.FC<ImageProps> = (props: ImageProps): JSX.Element => {
  const { src, alt, onClick, hideOnError, className }: ImageProps = props;
  const [hasError, setHasError]: UseState<boolean> = useState<boolean>(false);

  if (hasError && hideOnError) {
    return <React.Fragment />;
  }

  return (
    <React.Fragment>
      {hasError && (
        <BrokenImageBox className={className} onClick={onClick} data-testid='broken-image-box'>
          <Icon name={IconName.Image} color={Color.Gray400} size={60} />
        </BrokenImageBox>
      )}
      <Img 
        className={className} 
        src={src} 
        alt={alt} 
        onClick={onClick}
        onError={(): void => setHasError(true)} 
        onLoad={(): void => setHasError(false)}
        $isLoad={!hasError}
      />
    </React.Fragment>
  );
};
